export enum ECardTitleColor {
  default,
  cLink,
  cAccent2,
}
